import UPSnackBar from './UPSnackbar';

export default UPSnackBar;
